<template>
  <div class="d-flex flex-wrap" style="gap: .5rem">
    <template v-if="showAvatar">
      <b-avatar
        size="35px"
        variant="primary"
        :text="currentLocation.user.userInitials"
        :src="currentLocation.user.avatar"
        v-b-popover.hover.top="currentLocation.user.name"
      >
      </b-avatar>
    </template>
    <template v-else>
      <b-badge
      pill
      class="p-1 px-2"
      :variant="currentLocation.badgeVariant"
      v-b-popover.hover.top="`${currentLocation.type}: ${currentLocation.name}`"
      >{{currentLocation.name}}
      </b-badge>
    </template>

  </div>
</template>

<script>
import commonsApi from '@/api/commons'

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    showAvatar () {
      return this.value.currentLocation?.user
    }
  },
  data () {
    return {
      currentLocation: {
        type: '',
        name: '',
        user: {}
      }
    }
  },
  methods: {
    async expandCurrentLocation () {
      if (this.value.currentLocation?.user) {
        const res = await commonsApi.axiosGetWrapper(`/users/user-meta/${this.value.currentLocation?.user?.id}`)
        const userInfo = res.data
        this.currentLocation = {
          type: 'user',
          user: {
            name: `${userInfo.firstname} ${userInfo.lastname}`,
            userInitials: res.data?.userInitials,
            avatar: userInfo?.profilePicture || ''
          }
        }
      } else {
        let locationType
        let locationName
        let locationBadgeVariant = 'danger'
        if (this.value.currentLocation?.area) {
          locationType = 'area'
          locationName = this.value.currentLocation.area?.name
        } else if (this.value.currentLocation?.subarea) {
          locationType = 'subarea'
          locationName = this.value.currentLocation.subarea?.name
          locationBadgeVariant = 'info'
        } else if (this.value.currentLocation?.group) {
          locationType = 'grupo'
          locationName = this.value.currentLocation.group?.name
          locationBadgeVariant = 'warning'
        }
        this.currentLocation = {
          type: locationType,
          name: locationName,
          badgeVariant: locationBadgeVariant
        }
      }
    }
  },
  async created () {
    try {
      await this.expandCurrentLocation()
    } catch (error) {
      console.log(error)
    }
  }
}
</script>

<style lang="sass" scoped>
.recipients-large
  cursor: pointer
</style>
